import { DynamicFormInputType, FormInputTypes } from '@components/_old/dynamicForm';
import { isEmpty } from '@utils/validationUtils';

export const initialValues = {
  company: '',
  type: '',
  fromDate: '',
  toDate: '',
};

export const inputs = (
  mode: 'add' | 'edit' = 'add',
  values: Record<string, any> = initialValues,
  lovs: Record<string, Record<string, string>>
): Record<string, DynamicFormInputType> => ({
  company: {
    name: 'company',
    title: 'Company',
    type: FormInputTypes.newselect,
    disabled: mode === 'edit',
    value: !isEmpty(values.company) ? values.company : [],
    selectOptions: lovs?.relatedCompanies,
    required: true,
  },
  type: {
    name: 'type',
    title: 'Transfer Type',
    type: FormInputTypes.newselect,
    disabled: false,
    value: !isEmpty(values.type) ? values.type : [],
    selectOptions: lovs?.type,
    required: true,
  },
  fromDate: {
    name: 'fromDate',
    title: 'Transfer From Date',
    type: FormInputTypes.newdate,
    value: values.fromDate,
    required: true,
    disabled: false,
  },
  toDate: {
    name: 'toDate',
    title: 'Transfer To Date',
    type: FormInputTypes.newdate,
    value: values.toDate,
    required: true,
    disabled: false,
  },
});
